import type { ReactNode } from 'react'

export interface LearnerRouteBoundaryProps {
  readonly children: ReactNode
}

export function LearnerRouteBoundary({ children }: LearnerRouteBoundaryProps) {
  return children
}
